<template>
    <base-order id="express_order" name="Encomenda Favoritos" subtitleName="(últimos 365 dias)" endpoint="/api/orders/express" :model="model" :schema="schema" :headers="headers" :advanced_filters="advanced_filters" :account-blocked-message="accountBlockedMessage"></base-order>
</template>

<script>
import MainLayout from './../../Layouts/MainLayout';

export default {
    layout: MainLayout,

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        advanced_filters: Array,

        accountBlockedMessage: String,
    },
};
</script>
